import moment from "moment";
import { formatPhoneNumber } from "../../utils/phoneNumberFormatter";

export const ROLE_AND_RESPONSIBILITY = {
  ROLE_NAME: "roleName",
  DESCRIPTION: "description",
  TYPE: "type",
};

export const ROLE_AND_RESPONSIBILITY_OPTIONS = [
  { label: "User Admin", value: "userAdmin" },
  { label: "Provider Admin", value: "providerAdmin" },
];

export const ADD_NEW_DEPARTMENT_DATA = {
  DEPARTMENT_ID: "departmentId",
  DEPARTMENT_NAME: "departmentName",
  DEPARTMENT_ADMIN: "departmentAdmin",
  DEPARTMENT_CONTACT_NO: "departmentContactNo",
};

export const ADD_NEW_ROOM_DATA = {
  ROOM_NAME: "roomName",
  ROOM_NUMBER: "roomNumber",
  CAPACITY: "capacity",
  STATUS: "status",
};

export const ROOM_STATUS_OPTIONS = [
  { label: "Active", value: "Active" },
  { label: "In Active", value: "InActive" },
];

export const getRoomRowData = (roomList: any) =>
  (roomList?.rooms || roomList?.data || [])?.map((data: any) => ({
    id: data?.id || "-",
    roomName: data?.name || "-",
    roomNumber: data?.roomNumber || "-",
    capacity: data?.capacity ?? "-",
    currentOccupancy: data?.currentOccupancy ?? "-",
    status: data?.status || "-",
  }));

export const USER_PROFILE_DATA = {
  BSA_ID: "bsaId",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  PROVIDER_TYPE: "providerType",
  SPECIALITY: "speciality",
  NPI_NUMBER: "npiNumber",
  PROVIDER_NUMBER: "providerNumber",
  OFFICE_FAX_NUMBER: "officeFaxNumber",
  LICENSE_DATE: "licenseDate",
  LICENSE_NUMBER: "licenseNumber",
  ROLE: "role",
  GENDER: "gender",
  EMAIL: "email",
  WORK_LOCATION: "workLocation",
  TAXONOMY_NUMBER: "taxonomyNumber",
  STATUS: "status",
  CONTACT_NUMBER: "contactNumber",
  DEPARTMENT: "department",
  DEPARTMENT_NAME: "departmentName",
  PROVIDER_ACCESS: "providerAccess",
};

export const ADD_NEW_INVENTORY_DATA = {
  ITEM_NAME: "itemName",
  SKU_CODE: "skuCode",
  CATEGORY: "category",
  TYPE: "type",
  QUANTITY: "quantity",
  EXPIRATION_DATE: "expirationDate",
  THRESHOLD_VALUE: "thresholdValue",
};

export const TEMPLATE_DATA = {
  TEMPLATE_NAME: "templateName",
  DESCRIPTION: "description",
};

export const TEMPLATE_NAME = [
  {
    label: "Transfer Off Property",
    value: "Transfer Off Property",
  },
  {
    label: "Transfer to Clinic Location",
    value: "Transfer to Clinic Location",
  },
  { label: "Transfer to JHC", value: "Transfer to JHC" },
];
export const TEMPLATE_DESCRIPTIONS: { [key: string]: string } = {
  "Transfer Off Property": "This templated added for testing",
  "Transfer to Clinic Location": "This templated added for testing",
  "Transfer to JHC": "This templated added for testing",
};

export const CODE_DATA = {
  CODE_NAME: "codeName",
  DESCRIPTION: "description",
  DIAGNOSIS_NAME: "diagnosisName",
};

export const ADD_NEW_PATIENT_DATA = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  BSA_ID: "bsaId",
  DOB: "dateOfBirth",
  EMAIL: "email",
  CONTACT_NUMBER: "contact",
  GENDER: "gender",
  CLINIC_LOCATION: "clinicLocation",
  JAMBOREE_UNIT_NUMBER: "jamboreeUnitNumber",
  JAMBOREE_UNIT_LEADER_NAME: "jamboreeUnitLeaderName",
  JAMBOREE_UNIT_LEADER_EMAIL: "jamboreeUnitLeaderEmail",
  EMERGENCY_CONTACT_NAME: "emergencyContactName",
  EMERGENCY_CONTACT_RELATION: "emergencyContactRelation",
  EMERGENCY_EMAIL: "emergencyEmail",
  EMERGENCY_CONTACT_NUMBER: "emergencyContactNumber",
};

export const EMERGENCY_CONTACT_RELATIONS = [
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Self", value: "Self" },
];

export const GENDER = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

export const GENDER2 = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const PROVIDER_ACCESS_OPTIONS = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export const SPECIALTY_TYPE = [
  { label: "Cardiology", value: "cardiology" },
  { label: "Neurology", value: "neurology" },
  { label: "Orthopedics", value: "orthopedics" },
  { label: "Pediatrics", value: "pediatrics" },
  { label: "Oncology", value: "oncology" },
  { label: "Dermatology", value: "dermatology" },
  { label: "Gynecology", value: "gynecology" },
  { label: "Gastroenterology", value: "gastroenterology" },
  { label: "Endocrinology", value: "endocrinology" },
  { label: "Psychiatry", value: "psychiatry" },
  { label: "Ophthalmology", value: "ophthalmology" },
  { label: "Pulmonology", value: "pulmonology" },
  { label: "Urology", value: "urology" },
  { label: "Nephrology", value: "nephrology" },
  { label: "Rheumatology", value: "rheumatology" },
  { label: "Hematology", value: "hematology" },
  { label: "Radiology", value: "radiology" },
  { label: "Emergency Medicine", value: "emergency_medicine" },
  { label: "Anesthesiology", value: "anesthesiology" },
  { label: "Surgery", value: "surgery" },
  { label: "Primary Care", value: "primary_care" },
  { label: "Pathology", value: "pathology" },
  { label: "Rehabilitation Medicine", value: "rehabilitation_medicine" },
  { label: "Other", value: "other" },
];

export const ADD_FACILITY_DETAILS = {
  FACILITY_NAME: "facilityName",
  CONTACT_PERSON: "contactPerson",
  PLACE_OF_SERVICES: "placeOfServices",
  CMO_NAME: "cmoName",
  CNO_NAME: "cnoName",
  CAO_NAME: "caoName",
  CMO_CONTACT_NUMBER: "cmoContactNumber",
  CNO_CONTACT_NUMBER: "cnoContactNumber",
  CAO_CONTACT_NUMBER: "caoContactNumber",
  SPECIALITY_TYPE: "specialityType",
  WEBSITE: "website",
  FAX_ID: "faxId",
  FAX_NUMBER: "faxNumber",
  IS_BASECAMP: "isBasecamp",
  ADDRESS_1: "address_1",
  ADDRESS_2: "address_2",
  CITY: "city",
  STATE: "state",
  COUNTRY: "country",
  ZIP_CODE: "zipCode",
  EMAIL: "Email",
  CONTACT_NUMBER: "contactNumber",
  DATE_OF_BIRTH: "BirthDate",
};

export const UPLOAD_IMPORT_DATA = {
  ENTITY_NAME: "entity",
};
export const ENTITY_NAME = [
  {
    label: "ICD10",
    value: "ICD10",
  },
  { label: "DSM", value: "DSM" },
];
// COMBINE ADDRESS FUNCTION
export function mapAddressToLocation(address: any): string {
  const { addressLine1, addressLine2, city, state, country, pinCode } = address;

  const parts = [
    addressLine1,
    addressLine2,
    city,
    state,
    pinCode,
    country,
  ]?.filter((part) => part && part?.trim() !== "");

  return parts.join(" ");
}

// RETURN CAMP PROFILE DETAILS
export const getCampDetails = (baseCampDetails: any) => {
  return [
    {
      label: "Base Camp",
      value: baseCampDetails?.facility?.name || "-",
    },
    {
      label: "Address",
      value: baseCampDetails?.facility?.address?.addressLine1
        ? mapAddressToLocation(baseCampDetails?.facility?.address)
        : "-",
    },
    {
      label: "Email",
      value: baseCampDetails?.facility?.email || "-",
    },
    {
      label: "Contact Number",
      value: baseCampDetails?.facility?.contactNumber
        ? formatPhoneNumber(baseCampDetails?.facility?.contactNumber)
        : "-",
    },
    {
      label: "Number Of Department",
      value: baseCampDetails?.facility?.numberOfDepartments || "0",
    },
    {
      label: "Status",
      value: baseCampDetails?.facility?.status || "-",
    },
    // { label: "Base Camp ID", value: "-" },
    {
      label: "Base Camp Admin",
      value: baseCampDetails?.facility?.contactPerson || "-",
    },
  ];
};

// GET DEPARTMENT ROW DATA
export const getDepartmentRowData = (departmentList: any) => {
  return departmentList?.department?.map((data: any) => ({
    id: data?.id || "-",
    departmentId: data?.departmentId || "-",
    departmentName: data?.name || "-",
    departmentAdmin: data?.adminName || "-",
    contactNumber: data?.contactNumber
      ? formatPhoneNumber(data?.contactNumber)
      : "-",
    status: data?.status,
  }));
};

export const getPatientRowData = (patientListData: any) => {
  return patientListData?.patient?.map((data: any) => {
    return {
      patientId: data?.id,
      bsaId: data?.participant?.bsaId || "-",
      patientName:
        `${data?.participant?.firstName} ${data?.participant?.lastName}` || "-",
      gender: data?.participant?.gender || "-",
      visitType:
        data?.visitType === "EMS_Visit"
          ? "EMS"
          : data?.visitType === "WALK_In_Visit"
            ? "Walk-In"
            : "-",
      // baseCamp: data?.participant?.baseCamp?.name || "-",
      status: data?.status || "-",
      contactNo: data?.participant?.contactNumber
        ? formatPhoneNumber(data?.participant?.contactNumber)
        : "-",
      emergencyContact: data?.participant?.emergencyContact?.[0]?.contactNumber
        ? formatPhoneNumber(
            data?.participant?.emergencyContact?.[0]?.contactNumber
          )
        : "-",
      emergencyContactName:
        data?.participant?.emergencyContact?.[0]?.contactName || "-",
      emergencyContactEmail:
        data?.participant?.emergencyContact?.[0]?.contactEmail || "-",
      emergencyContactRelation:
        data?.participant?.emergencyContact?.[0]?.contactRelation || "-",
      dateOfBirth: data?.participant?.dateOfBirth
        ? // DOB is date-only (midnight UTC) — render in UTC so it never shifts.
          moment.utc(data?.participant?.dateOfBirth).format("MM/DD/YYYY")
        : "-",
      email: data?.participant?.email || "-",
      baseCamp: data?.participant?.baseCamp?.name || "-",
      jun: data?.participant?.baseCamp?.unitNumber || "-",
      jula: data?.participant?.baseCamp?.leaderName || "-",
    };
  });
};

export const getInventoryListData = (inventoriesList: any) => {
  return inventoriesList?.data?.map((data: any) => ({
    itemName: data?.inventory?.itemName || "-",
    category: data?.inventory?.type || "-",
    stockLevel: data?.currentStock || "0",
    reorderPoint: data?.threshold || "0",
    status: data?.status.split("_").join(" "),
    expirationDate: data?.expirationDate
      ? // Date-only value (midnight UTC) — render in UTC so it never shifts.
        moment.utc(data?.expirationDate).format("MM/DD/YYYY")
      : "-",
    order: data?.orderQuantity || "0",
    skuCode: data?.inventory?.skuCode || "-",
    id: data?.id || "-",
    orderStatus: data?.orderStatus || "-",
  }));
};

export const getFacilityUserData = (userList: any) => {
  return userList?.users?.map((data: any) => ({
    id: data?.id || "-",
    providerName: `${data?.firstName} ${data?.lastName}` || "-",
    email: data?.email || "-",
    contactNumber: data?.contactNumber
      ? formatPhoneNumber(data?.contactNumber)
      : "-",
    status: data?.status,
    bsaId: data?.bsaId || "-",
    role: data?.role?.name || "-",
    departments: data?.departmentUsers || [],
    departmentName:
      data?.departmentUsers
        ?.map((dept: any) => dept?.department?.name)
        .join(", ") || "-",
    firstName: data?.firstName,
    lastName: data?.lastName,
    gender: data?.gender,
  }));
};

export const getHeadingTitle = (selectedTab: string, defaultData: any) => {
  if (selectedTab === "Staff" && defaultData?.bsaId) {
    return "Edit Staff User";
  } else if (selectedTab === "Provider" && defaultData?.bsaId) {
    return "Edit Provider User";
  } else if (selectedTab === "Provider") {
    return "Add Provider User";
  } else if (selectedTab === "Staff") {
    return "Add Staff User";
  }
};

export const getHeadingViewTitle = (selectedTab: string, defaultData: any) => {
  if (selectedTab === "Staff" && defaultData?.bsaId) {
    return "View Staff Profile";
  } else if (selectedTab === "Provider" && defaultData?.bsaId) {
    return "View Provider Profile";
  }
};
